import React, { Component } from 'react';
import { Button } from '@cimpress/react-components';

export default class ButtonDemo extends Component {
  state = {
    demoText: 'Welcome, click some buttons!',
  };

  buttonClicked = button => {
    this.setState({
      demoText: `"${button.target.innerText}" was just clicked.`,
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="well" style={{ marginBottom: '20px' }}>
            {this.state.demoText}
          </div>
        </div>
        <div
          className="col-md-12"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button variant="default" onClick={this.buttonClicked}>
            Default
          </Button>
          <Button variant="primary" onClick={this.buttonClicked}>
            Primary
          </Button>
          <Button href="#" variant="link" onClick={this.buttonClicked}>
            Link
          </Button>
          <Button href="#" target="_blank" variant="link" onClick={this.buttonClicked}>
            Link in new tab
          </Button>
          <Button variant="anchor" onClick={this.buttonClicked}>
            Anchor
          </Button>
          <Button disabled={true} onClick={this.buttonClicked}>
            Disabled
          </Button>
        </div>
        <div
          className="col-md-12"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button variant="primary" size="lg" onClick={this.buttonClicked}>
            Large button
          </Button>
          <Button variant="primary" size="sm" onClick={this.buttonClicked}>
            Small button
          </Button>
          <Button className="custom-additional-classes my-button" onClick={this.buttonClicked}>
            Custom Classes Added
          </Button>
        </div>

        <div className="col-md-12" style={{ margin: '5px' }}>
          <Button variant="primary" blockLevel={true} onClick={this.buttonClicked}>
            Block level Button
          </Button>
        </div>
      </div>
    );
  }
}
